const LANDING_PAGE_KEY = 'elev8_landing_page';
const PENDING_LEAD_ATTRIBUTION_KEY = 'elev8_pending_lead_attribution';

export type OfferType =
  | 'consultation'
  | 'demo'
  | 'audit'
  | 'calculator'
  | 'callback'
  | 'question'
  | 'general'
  // Website + 3 months of waived ad management, Aug 1 - Sept 30 2026.
  | 'website_ads_offer';

export interface LeadAttribution {
  cta_name: string;
  cta_location: string;
  offer_type: OfferType;
  service_context: string;
  form_variant: string;
  landing_page: string;
  page_path: string;
  referrer: string;
}

function getCurrentPath(): string {
  if (typeof window === 'undefined') return '';
  return `${window.location.pathname}${window.location.search}`;
}

export function getLandingPage(): string {
  if (typeof window === 'undefined') return '';

  const currentPath = getCurrentPath();
  const existing = window.sessionStorage.getItem(LANDING_PAGE_KEY);
  if (existing) return existing;

  window.sessionStorage.setItem(LANDING_PAGE_KEY, currentPath);
  return currentPath;
}

export function buildLeadAttribution(
  overrides: Partial<LeadAttribution> = {}
): LeadAttribution {
  const pagePath = getCurrentPath();

  return {
    cta_name: overrides.cta_name || 'direct_form_start',
    cta_location: overrides.cta_location || 'embedded_contact_form',
    offer_type: overrides.offer_type || 'general',
    service_context: overrides.service_context || 'general',
    form_variant: overrides.form_variant || 'multi_step_contact_form',
    landing_page: overrides.landing_page || getLandingPage(),
    page_path: overrides.page_path || pagePath,
    referrer:
      overrides.referrer ||
      (typeof document !== 'undefined' ? document.referrer || '' : ''),
  };
}

export function setPendingLeadAttribution(
  attribution: Partial<LeadAttribution>
): LeadAttribution {
  const normalized = buildLeadAttribution(attribution);

  if (typeof window !== 'undefined') {
    window.sessionStorage.setItem(
      PENDING_LEAD_ATTRIBUTION_KEY,
      JSON.stringify(normalized)
    );
  }

  return normalized;
}

export function getPendingLeadAttribution(
  fallback: Partial<LeadAttribution> = {}
): LeadAttribution {
  if (typeof window === 'undefined') return buildLeadAttribution(fallback);

  const raw = window.sessionStorage.getItem(PENDING_LEAD_ATTRIBUTION_KEY);
  if (!raw) return buildLeadAttribution(fallback);

  try {
    return buildLeadAttribution({
      ...JSON.parse(raw),
      ...fallback,
    });
  } catch {
    return buildLeadAttribution(fallback);
  }
}
